import { createPage, createFlow } from '../utils';
import { MALE } from '../../gender';
import i18n from '../../../plugins/i18n';
import { REPEAT } from '../variables';
import { APPOINTMENT_TYPES } from '../../appointment';
import { NODE_ENV } from '../../env';
import { PRETTY_DATE_FORMAT, TWELVE_HOUR_TIME_FORMAT } from '../../moment';
import { IS_RETURNING_PATIENT } from '../../store';
import lps from '../../lp';
import { initCannabisSchedule } from '../config/cannabis/schedule';

const RegisterNewReturningTwo = createPage({
  name: 'RegisterNewReturningTwo',
  nextPage: (state) => {
    if (IS_RETURNING_PATIENT(state)) {
      return 'RegisterIntroduceReturning';
    }
    return 'RegisterIntroduce';
  },
  options: {
    showFooter: false,
    hideHeader: true,
    pageConfig: {
      buttonActive: true,
      init: (store) => {
        store.commit('setRegistration', {
          restrictShiftsByEmployee: false,
        });
      },
      para1: i18n.t('registration.cannabis.registerNewReturning.para1'),
    },
  },
});
const RegisterIntroduceReturning = createPage({
  name: 'RegisterIntroduceReturning',
  componentName: 'RegisterIntroduce',
  nextPage: (state) => {
    if (IS_RETURNING_PATIENT(state)) {
      return 'RegisterInform';
    }
    return 'RegisterIntroduce';
  },
  options: {
    pageConfig: {
      checkUserAttempts: 3,
      checkForExistingUser: true,
      isEmailOptional: true,
      showConsent: false,
      showEmail: false,
      showFirstName: false,
      showLastName: false,
      showDob: false,
      showPhone: false,
      showGender: false,
      healthCardVersionDisabled: true,
      healthCardExpiryDisabled: true,
      pageTitle: i18n.t('registration.cannabis.registerIntroduceReturning.pageTitle'),
      pageSubtitle: i18n.t('registration.cannabis.registerIntroduceReturning.pageSubtitle'),
      oneRow: true,
      returning: true,
    },
  },
});
const RegisterIntroduce = createPage({
  name: 'RegisterIntroduce',
  nextPage: 'RegisterInform',
  options: {
    pageConfig: {
      checkForExistingUser: true,
      healthCardExpiryOptional: true,
      healthCardVersionOptional: true,
      isEmailOptional: true,
      showGender: true,
      showEmail: true,
      showAddress: true,
      showPoBox: true,
      pageTitle: i18n.t('registration.cannabis.registerIntroduce.pageTitle'),
      patientData: {
        gender: MALE,
      },
    },
  },
});
const RegisterInform = createPage({
  name: 'RegisterInform',
  nextPage: 'RegisterSchedule',
  options: {
    pageConfig: {
      // eslint-disable-next-line no-unused-vars
      init: (store, vars, vm) => {
        store.commit('setRegistration', {
          // Set default reason for visit to 'Cannabis'
          memberAttributes: ['Cannabis'],
          // Set default reason for referral to 'non-psych'
          additionalComments: i18n.t('registration.cannabis.registerInform.nonPsych'),
          // Set appt type to 'video'
          appointmentType: APPOINTMENT_TYPES.video,
        });

        const { isReturningPatient } = store.state.registration;

        let form;

        if (isReturningPatient) {
          form = {
            questionOne: {
              variableName: 'symptomRelief',
              displayText: i18n.t('registration.cannabis.registerInform.form.symptomRelief'),
              noteLabel: i18n.t('registration.cannabis.registerInform.form.cannabisPatient'),
              infoText: null,
              show: true,
              value: false,
            },

            questionTwo: {
              variableName: 'doseIncrease',
              displayText: i18n.t('registration.cannabis.registerInform.form.doseIncrease'),
              noteLabel: i18n.t('registration.cannabis.registerInform.form.doseIncrease'),
              infoText: null,
              show: true,
              value: false,
            },
            questionThree: {
              variableName: 'currentLP',
              displayText: i18n.t('registration.cannabis.registerInform.form.currentLP'),
              noteLabel: i18n.t('registration.cannabis.registerInform.form.currentLP'),
              infoText: null,
              show: false,
              value: null,
              type: 'select',
              items: lps,
              selection: null,
            },
            questionFour: {
              variableName: 'isVeteran',
              displayText: null,
              noteLabel: i18n.t('registration.cannabis.registerInform.form.isVeteran'),
              infoText: null,
              show: true,
              value: false,
            },
            questionFive: {
              variableName: 'kNumber',
              type: 'input',
              displayText: null,
              noteLabel: i18n.t('registration.cannabis.registerInform.form.kNumber'),
              infoText: null,
              show: true,
              value: null,
              mask: 'K#######',
              showIf: (f) => {
                try {
                  const { questionFour } = f;
                  const { value } = questionFour;
                  return value;
                } catch {
                  return false;
                }
              },
            },
          };
        } else {
          form = {
            questionOne: {
              variableName: 'cannabisPatient',
              displayText: i18n.t('registration.cannabis.registerInform.form.cannabisPatient'),
              noteLabel: i18n.t('registration.cannabis.registerInform.form.cannabisPatient'),
              infoText: null,
              show: true,
              value: false,
            },
            questionTwo: {
              variableName: 'currentRx',
              displayText: i18n.t('registration.cannabis.registerInform.form.currentRx'),
              noteLabel: i18n.t('registration.cannabis.registerInform.form.currentRx'),
              infoText: null,
              show: true,
              value: null,
              type: 'input',
              inputType: 'number',
              optional: true,
              min: 0,
            },
            questionThree: {
              variableName: 'thcLimit',
              displayText: i18n.t('registration.cannabis.registerInform.form.thcLimit'),
              noteLabel: i18n.t('registration.cannabis.registerInform.form.thcLimit'),
              infoText: null,
              show: true,
              value: false,
              type: 'input',
              inputType: 'number',
              optional: true,
              min: 0,
            },
            questionFour: {
              variableName: 'isVeteran',
              displayText: null,
              noteLabel: i18n.t('registration.cannabis.registerInform.form.isVeteran'),
              infoText: null,
              show: true,
              value: false,
            },
            questionFive: {
              variableName: 'kNumber',
              type: 'input',
              displayText: null,
              noteLabel: i18n.t('registration.cannabis.registerInform.form.kNumber'),
              infoText: null,
              show: true,
              value: null,
              mask: 'K#######',
              showIf: (f) => {
                try {
                  const { questionFour } = f;
                  const { value } = questionFour;
                  return value;
                } catch {
                  return false;
                }
              },
            },
          };
        }
        // eslint-disable-next-line no-param-reassign
        vm.form = {
          ...vm.form,
          ...form,
        };
        if (store.state.registration.patientData.notes.basicNotes.length) return;
        store.commit('addDefaultPatientNotes', {
          basicNotes: Object.keys(form).map((k) => {
            const { type } = form[k];
            return `${form[k].noteLabel}: ${!type ? 'false' : ''}`;
          }),
        });
      },
      commPreferenceSubtitle: i18n.t('registration.registerInform.videoCallCaveat'),
      enabledAppointmentTypes: [APPOINTMENT_TYPES.video],

      reasonForVisit: i18n.t('registration.cannabis.registerInform.cannabisReferral'),
      isReasonForVisitFixed: true,
      pageTitle: i18n.t('registration.cannabis.registerInform.pageTitle'),
      pageSubtitle: i18n.t('registration.cannabis.registerInform.pageSubtitle'),
    },
  },
});

const RegisterSchedule = createPage({
  name: 'RegisterSchedule',
  nextPage: () => 'RegisterComplete',
  options: {
    pageConfig: {
      // eslint-disable-next-line no-unused-vars
      init: initCannabisSchedule,
      allowAppointmentRequest: false,
      appointmentDuration: 10,
      eventColor: '#dffff7',
      pageTitle: i18n.t('registration.cannabis.registerSchedule.pageTitle'),
      pageSubtitle: i18n.t('registration.cannabis.registerSchedule.pageSubtitle'),
    },
  },
});

const attributes = {
  DEV: ['7vqaU5R3PUjDhGYTG3uw', 'BDTeSzRhblxUE3wjwPQF'],
  QA: ['OpOkLERA3FePWb3Bca5g', 'NEjxtvhLGcsWIAUlkqZR'],
  PROD: ['3cz2wScF6TrUiJiw7PEs', 'Epw58lGIl3d51SzoSbsO'],
};

const languageAttributes = {
  DEV: {
    english: 'iCpcyteXihl8vt9I8rmf',
    french: 'RjizqTM6cDRm81t7Yr4y',
  },
  QA: {
    english: 'LydUmnz0uoUjd6kPLo2s',
    french: 'mdbHTZTm3jADdAKn9mJU',
  },
  PROD: {
    english: 'MepkPt9GioQCywYF3Inp',
    french: 'epPOO4jSrEa1xbgjWx7q',
  },
};
const locations = {
  DEV: 'nJU10TXxWQCNu9tu9v9j',
  QA: '0W4rOMWPDCtwMv1fj0np',
  PROD: 'k3ei7ZYD6Su0kLWu1QtI',
};
const RegisterComplete = createPage({
  name: 'RegisterComplete',
  nextPage: 'RegisterFileUpload',
  options: {
    pageConfig: {
      init: async (store, vars, vm) => {
        const isFrench = vm.$route.query.lang === 'fr';
        if (!store) return;
        const tenantUrl = store.state.registration.tenantUrl || localStorage.tenantUrl;
        if (NODE_ENV === 'development' && tenantUrl === 'demo') {
          store.commit('setRegistration', {
            memberAttributes: [
              ...attributes.DEV,
              isFrench ? languageAttributes.DEV.french : languageAttributes.DEV.english,
            ],
          });
          store.commit('setLocation', { id: locations.DEV });
        } else if (NODE_ENV === 'qa' && tenantUrl === 'demo') {
          store.commit('setRegistration', {
            memberAttributes: [
              ...attributes.QA,
              isFrench ? languageAttributes.QA.french : languageAttributes.QA.english,
            ],
          });
          store.commit('setLocation', { id: locations.QA });
        } else if (NODE_ENV === 'production' && tenantUrl === 'sentry-health') {
          store.commit('setRegistration', {
            memberAttributes: [
              ...attributes.PROD,
              isFrench ? languageAttributes.PROD.french : languageAttributes.PROD.english,
            ],
          });
          // Virtual clinic
          store.commit('setLocation', { id: locations.PROD });
        }
      },
      buttonText: i18n.t('main.continue'),
      cardText: i18n.t('registration.registerComplete.defaultFlow.cardText'),
      cardTitle: i18n.t('registration.registerComplete.trt.cardTitle'),
      clickToContinue: false,
      isEndOfRegistration: false,
      checkForExistingUser: true,
    },
  },
});

const RegisterFileUpload = createPage({
  name: 'RegisterFileUpload',
  nextPage: 'RegisterLogout',
  options: {
    clearHistory: true,
    pageConfig: {
      init: (store, vars, vm) => {
        const fields = [];
        const { lang } = vm.$route?.query || {};
        if (store.state.registration.patientData.firstName) {
          fields.push(
            `${i18n.t('main.patient')}: ${i18n.t(
              'format.fullName',
              store.state.registration.patientData
            )}`
          );
        }
        fields.push(`${i18n.t('main.provider')}: ${store.state.registration.employeeName}`);
        fields.push(
          `${i18n.t('main.appointment')}: ${store.state.registration.appointmentTime
            .lang(lang || 'en')
            .format(
              `${PRETTY_DATE_FORMAT} [${lang === 'fr' ? 'à' : 'at'}] ${
                lang === 'fr' ? 'HH:mm' : TWELVE_HOUR_TIME_FORMAT
              }`
            )}`
        );
        // eslint-disable-next-line no-param-reassign
        vm.customModalSubtitle = fields.join('\n');
      },
      isEndOfRegistration: true,
      leadLocations: [],
      pageTitle: i18n.t('registration.cannabis.registerFileUpload.pageTitle'),
      maxFiles: 25,
    },
  },
});

const RegisterLogout = createPage({
  name: 'RegisterLogout',
  nextPage: REPEAT,
  options: {
    clearHistory: true,
  },
});

const mendo = createFlow({
  landing: 'RegisterNewReturningTwo',
  onError: 'RegisterIntroduce',
  theme: 'mendo',
  type: 'cannabis',
  flow: {
    RegisterNewReturningTwo,
    RegisterIntroduceReturning,
    RegisterIntroduce,
    RegisterInform,
    RegisterSchedule,
    RegisterComplete,
    RegisterFileUpload,
    RegisterLogout,
  },
});

export default mendo;
